import React, { PureComponent } from 'react';

class SectorField extends PureComponent {
    render() {
        const { sector, setSector } = this.props;

        return (
            <div className="fieldwrap ">
                <label htmlFor="sector">
                    Do you work for a private sector organisation (such as a company), public sector
                    body (such as local or national government, a school or the health service), or
                    a non-profit organisation (such as a charity)?
                </label>
                <div className="row">
                    <div className="col-sm-auto">
                        <label
                            onClick={e => setSector('private')}
                            className={
                                sector == 'private' ? 'radio __active' : 'radio'
                            }
                        >
                            <input type="radio" name="sector" /> Private sector
                        </label>
                    </div>
                    <div className="col-sm-auto">
                        <label
                            onClick={e => setSector('public')}
                            className={
                                sector == 'public' ? 'radio __active' : 'radio'
                            }
                        >
                            <input type="radio" name="sector" /> Public sector
                        </label>
                    </div>
                    <div className="col-sm-auto">
                        <label
                            onClick={e => setSector('non-profit')}
                            className={
                                sector == 'non-profit' ? 'radio __active' : 'radio'
                            }
                        >
                            <input type="radio" name="sector" /> Non-profit organisation
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

export default SectorField;



// WEBPACK FOOTER //
// ./src/Form/SectorField.js